module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    class: 'col ' + _vm.wrapperClass
  }, [_c('div', {
    staticClass: "inline-group"
  }, [_c('label', {
    staticClass: "toggle"
  }, [_vm._v("\n        " + _vm._s(_vm.label) + "\n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerValue),
      expression: "innerValue"
    }],
    attrs: {
      "type": "checkbox",
      "name": _vm.name
    },
    domProps: {
      "checked": Array.isArray(_vm.innerValue) ? _vm._i(_vm.innerValue, null) > -1 : (_vm.innerValue)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.innerValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.innerValue = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.innerValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.innerValue = $$c
        }
      }
    }
  }), _vm._v(" "), _c('i', {
    attrs: {
      "data-swchon-text": "SIM",
      "data-swchoff-text": "NÃO"
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a443c49"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Fields/AbstractCheckboxField.vue
// module id = 969
// module chunks = 1